import { templateStore } from '../template/index.js';
import { USER_ROLES } from './constants.js';
import { formatDate } from '../date-picker/utilities.js';
import { getStatusConfig } from './util/config.js';


/**
 * Render complete question section
 * @param {Object} options - Rendering options
 */
export function renderQuestionModule(options) {
	const { questions, userRole, totalQuestions } = options;

	const titleContainer = document.getElementById('list-title');
	const mainContainer = document.getElementById('list-question');
	const detailContainer = document.getElementById('detail-question');
	const emptyContainer = document.getElementById('empty-question');
	const moduleWrapper = document.getElementById('main-module');

	if (!mainContainer || !detailContainer) return;


	// Case: student and truly no questions at all (not just filtered empty)
	const isStudent = userRole === USER_ROLES.STUDENT;
	const hasNoQuestions = !questions || questions.length === 0;
	const allEmpty = totalQuestions !== undefined ? totalQuestions === 0 : hasNoQuestions;

	if (isStudent && allEmpty) {
		if (emptyContainer) {
			const emptyTemplate = templateStore.get('student-question/empty.ejs');
			// eslint-disable-next-line no-undef
			emptyContainer.innerHTML = ejs.render(emptyTemplate);
			emptyContainer.classList.remove('hidden');
		}
		if (moduleWrapper) {
			moduleWrapper.classList.add('hidden');
		}
		return;
	}

	// Normal case: questions exist or role is coach
	if (emptyContainer) {
		emptyContainer.innerHTML = '';
		emptyContainer.classList.add('hidden');
	}
	if (moduleWrapper) moduleWrapper.classList.remove('hidden');

	// Step 1: Render List Title (Student only)
	if (titleContainer && userRole === USER_ROLES.STUDENT) {
		const titleTemplate = templateStore.get('student-question/list-title.ejs');
		const listTitle = userRole === USER_ROLES.COACH ? wpcore.direct_t({ en: 'Student Questions', fr: 'Questions des étudiants' }) : wpcore.direct_t({ en: 'My Submitted Questions', fr: 'Mes questions soumises' });

		// eslint-disable-next-line no-undef
		titleContainer.innerHTML = ejs.render(titleTemplate, { listTitle });
	} else if (titleContainer) {
		titleContainer.innerHTML = '';
	}

	// Step 2 & 3: Prepare Items and Render List Container in one-shot
	const customizedStatusConfig = getStatusConfig(userRole);

	let itemsHtml = `<p class="text-gray-700 text-sm">${wpcore.direct_t({ en: 'No questions found.', fr: 'Aucune question trouvée.' })}</p>`;
	if (questions && questions.length) {
		const itemTemplate = templateStore.get('student-question/item.ejs');
		// eslint-disable-next-line no-undef
		itemsHtml = questions.map(question => ejs.render(itemTemplate, {
			question,
			STATUS_CONFIG: customizedStatusConfig,
			formatDate
		})).join('');
	}

	const listTemplate = templateStore.get('student-question/list.ejs');
	const listTitle = userRole === USER_ROLES.COACH ? wpcore.direct_t({ en: 'Student Questions', fr: 'Questions des étudiants' }) : wpcore.direct_t({ en: 'My Submitted Questions', fr: 'Mes questions soumises' });
	// eslint-disable-next-line no-undef
	mainContainer.innerHTML = ejs.render(listTemplate, { listTitle, itemsHtml });

	// Step 4: Render Detail View
	renderDetail(detailContainer, null, userRole, customizedStatusConfig);

	// Step 5: Reset mobile nav — always show list, hide detail when re-rendering
	if (window.innerWidth < 1024) {
		mainContainer.classList.remove('hidden');
		detailContainer.classList.add('hidden');
	}
}

/**
 * Render question detail
 * @param {HTMLElement} container - Container element
 * @param {Object|null} question - Question data
 * @param {string} userRole - Current user role
 * @param {Object} overrideConfig - Optional status config override
 */
export function renderDetail(container, question, userRole = USER_ROLES.STUDENT, overrideConfig = null) {
	if (!container) return;

	if (!question) {
		const emptyTemplate = templateStore.get('student-question/empty-detail.ejs');
		// eslint-disable-next-line no-undef
		container.innerHTML = ejs.render(emptyTemplate);
		return;
	}

	const statusConfig = overrideConfig || getStatusConfig(userRole);

	const template = templateStore.get('student-question/detail.ejs');
	try {
		// eslint-disable-next-line no-undef
		container.innerHTML = ejs.render(template, {
			question,
			STATUS_CONFIG: statusConfig,
			formatDate,
			userRole,
			USER_ROLES
		});
	} catch (err) {
		console.error('[renderDetail] EJS render error:', err);
	}
}

/**
 * Update total count display
 */
export function updateTotalCount(count) {
	const countEl = document.getElementById('total-questions');
	if (countEl) {
		countEl.textContent = count;
	}
}
